<template>
  <section class="schedule">
    <h1 class="title">Schedule</h1>

    <nav class="breadcrumb is-centered">
      <ul>
        <li :class="{ 'is-active': searchChoice == 'league' }"><router-link :to="{path: `/leagues/schedule/${season.id}`, query: {league: leagueId === null ? undefined : leagueId, search: 'league', 'league-view': leagueView}}">By League</router-link></li>
        <!-- <li :class="{ 'is-active': searchChoice == 'week' }"><router-link :to="`/leagues/schedule/${season.id}/?search=week`">By Week</router-link></li> -->
        <li :class="{ 'is-active': searchChoice == 'day' }"><router-link :to="`/leagues/schedule/${season.id}/?search=day`">By Day</router-link></li>
      </ul>
    </nav>

    <div v-if="searchChoice == 'day'" class="datepicker-wrapper">
      <datepicker
        :inline="true"
        :value="date"
        @selected="onDatePicked"
        autocomplete="off"
        id="schedule-date-input"
        placeholder="Select a date"
        :bootstrap-styling="false">
      </datepicker>
    </div>

    <h3 v-if="searchChoice == 'league'" class="subtitle" style="text-align: center; margin-top: 0; margin-bottom: 0.5rem;">Select a league</h3>
    <league-select-list v-if="searchChoice == 'league'" :leagues="season.leagues" :league-id.sync="leagueId"></league-select-list>

    <external-ad-list/>

    <h3 v-if="searchChoice == 'day'" class="subtitle" id="day-schedule-title">Day Schedule for {{ dayFormatted }}</h3>

    <nav v-if="searchChoice == 'league' && leagueId != null" class="breadcrumb is-centered">
      <ul>
        <li :class="{ 'is-active': leagueView == 'matches' }"><router-link :to="{name: 'schedule-league', query: {search: 'league', league: leagueId, 'league-view': 'matches'}}">Matches</router-link></li>
        <li :class="{ 'is-active': leagueView == 'teams' }"><router-link :to="{name: 'schedule-league', query: {search: 'league', league: leagueId, 'league-view': 'teams'}}">Teams and Standings</router-link></li>
        <li v-if="league != null && league.bracketLink != null" :class="{ 'is-active': leagueView == 'bracket' }"><router-link :to="{name: 'schedule-league', query: {search: 'league', league: leagueId, 'league-view': 'bracket'}}">Tournament Bracket</router-link></li>
      </ul>
    </nav>
    <h3 v-if="searchChoice == 'league' && leagueId != null" class="subtitle" id="league-schedule-title">{{ leagueSectionTitle }}</h3>

    <template v-if="!loading">
    <div v-if="(searchChoice == 'day' || searchChoice == 'week') && matches.length > 0" class="matches-list">
      <table class="table is-striped is-hoverable" v-for="group of matchGroups" :key="group.league.id">
        <caption class="subtitle table-caption">{{ group.league.name }}</caption>
        <thead>
          <tr>
            <th class="row-time">Time</th>
            <th class="row-court">Court</th>
            <th class="row-team row-home">Home</th>
            <th class="row-team row-away">Away</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="match of group.matches" :key="match.id">
            <td>{{ match.time }}</td>
            <td>{{ match.court }}</td>
            <td><schedule-team-detail :team="teams[`${match.league} ${match.home}`]" :season="season"></schedule-team-detail></td>
            <td><schedule-team-detail :team="teams[`${match.league} ${match.away}`]" :season="season"></schedule-team-detail></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else-if="(searchChoice == 'day' || searchChoice == 'week') && matches.length == 0"><h3 class="subtitle">There are no regular league matches scheduled for this day.</h3></div>
    </template>
    <div v-else-if="loading && (searchChoice == 'day' || searchChoice == 'week')" style="position: relative; min-height: 600px;"><shark-loader></shark-loader></div>

    <template v-if="!loading">
    <div v-if="leagueView == 'matches'">
      <div v-if="(searchChoice == 'league') && matches.length > 0 && leagueId != null" class="matches-list">
        <table class="table is-striped is-hoverable" v-for="group of dateGroupedMatches" :key="group.id">
          <caption class="subtitle table-caption">{{ group.dateFormatted }}</caption>
          <thead>
            <tr>
              <th class="row-time">Time</th>
              <th class="row-court">Court</th>
              <th class="row-team row-home">Home</th>
              <th class="row-team row-away">Away</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="match of group.matches" :key="match.id">
              <td>{{ match.time }}</td>
              <td>{{ match.court }}</td>
              <td><schedule-team-detail :team="teams[`${match.league} ${match.home}`]" :season="season"></schedule-team-detail></td>
              <td><schedule-team-detail :team="teams[`${match.league} ${match.away}`]" :season="season"></schedule-team-detail></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else-if="searchChoice == 'league' && leagueId != null && matches.length == 0"><h3 class="subtitle">No matches were found for this league.</h3></div>
    </div>

    <div v-else-if="leagueView == 'teams'">
      <table class="table is-striped is-hoverable" style="margin: 0 auto 1.5rem;">
        <thead>
          <tr>
            <th class="row-team-name">Team Name</th>
            <th class="row-captain">Captain</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="team of leagueTeams" :key="team.league.toString() + ' ' + team.id.toString()">
            <td><schedule-team-detail :team="team" :season="season"></schedule-team-detail></td>
            <td>{{ team.captain.name | capitalize }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else-if="leagueView == 'bracket'">
      <a v-if="league.bracketLink != null" :href="league.bracketLink" class="bracket-link">Tournament Bracket Link</a>
      <h3 v-else>No tournament bracket is available yet.</h3>
    </div>

    </template>
    <div v-else-if="loading && searchChoice == 'league'" style="position: relative; min-height: 600px;"><shark-loader></shark-loader></div>
  </section>
</template>

<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import ExternalAdList from '@/components/ExternalAdList.vue'
import LeagueSelectList from '@/components/LeagueSelectList.vue'
import ScheduleTeamDetail from '@/components/ScheduleTeamDetail.vue';

export default {
  name: 'Schedule',
  provide() {
    return {
      "teams": this.teams
    }
  },
  computed: {
    season() {
      let seasons = [this.$store.state.currentSeason, this.$store.state.upcomingSeason];
      let id = this.$route.params.seasonId;
      return seasons.filter(season => season != null && season.id == id)[0];
    },
    league() {
      return this.season.leagues.filter(league => league.id == this.leagueId)[0];
    },
    matchGroups() {
      return this.$store.getters.groupedMatches(this.season, this.matches);
    },
    teams() {
      let season = this.season;
      let leagues = season.leagues;
      let teams = {};
      for (let league of leagues) {
        for (let team of league.teams) {
          teams[`${league.id} ${team.name}`] = team;
        }
      }
      return teams;
    },
    leagueTeams() {
      let teams = this.league.teams;
      teams.sort((t1, t2) => t1.won == t2.won ? 0 : t1.won < t2.won ? 1 : -1);
      return teams;
    },
    dateGroupedMatches() {
      let matches = this.matches;
      let latestDate = null;
      let latestDateGroup = null;
      let dateGroupedMatches = [];
      for (let match of matches) {
        if (match.date != latestDate) {
          latestDate = match.date;
          let dateGroup = Object.create(null);
          dateGroup.date = latestDate;
          dateGroup.dateFormatted = moment(dateGroup.date).format("MMMM Do YYYY");
          dateGroup.matches = [];
          dateGroup.id = match.date.toString() + " " + match.id.toString();
          latestDateGroup = dateGroup;
          dateGroupedMatches.push(latestDateGroup);
        }
        latestDateGroup.matches.push(match);
      }
      for (let group of dateGroupedMatches) group.matches.sort(this.$store.getters.matchSorter);
      return dateGroupedMatches;
    },
    dayFormatted() {
      return moment(this.date).format("MMMM Do YYYY");
    },
    leagueSectionTitle() {
      if (this.leagueView == 'matches') return `Season Schedule for ${this.league.name}`;
      else if (this.leagueView == 'teams') return `Teams for ${this.league.name}`;
    }
  },
  components: {
    Datepicker,
    ExternalAdList,
    LeagueSelectList,
    ScheduleTeamDetail,
  },
  watch: {
    '$route': {
      // Some really cool stuff here :D
      handler: function() { return this.handleRoute(...arguments); },
      immediate: true
    },
    leagueId: {
      handler(value) {
        this.$router.push(`/leagues/schedule/${this.season.id}/?search=league&league=${value}`);
        this.$nextTick(() => this.$el.querySelector("#league-schedule-title").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"}));
      }
    }
  },
  data() {
    return {
      searchChoice: this.$route.query.search || "league" || null,
      leagueId: this.$route.query.league || null,
      leagueView: this.$route.query["league-view"] || "matches",
      date: this.$route.query.day ? moment(this.$route.query.day).toDate() : moment().toDate(),
      day: this.$route.query.day || moment().format("YYYY-MM-DD"),
      weekNumber: this.$route.query.week || 1,
      matches: [],
      loading: false,
      loadingCounter: 0
    }
  },
  methods: {
    onDatePicked(date) {
      this.date = date;
      if (this.date == null) {
        this.day = null;
        return;
      }
      this.day = moment(date).format("YYYY-MM-DD");
      this.$router.push(`/leagues/schedule/${this.season.id}/?search=day&day=${this.day}`);
      this.$nextTick(() => this.$el.querySelector("#day-schedule-title").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"}));
    },
    handleRoute(to, from) {
      if (!to.query.search && this.searchChoice) {
        this.$router.replace({path: `/leagues/schedule/${this.season.id}`, replace: true, query: {search: this.searchChoice}});
        return;
      }
      this.loading = false;
      this.searchChoice = to.query.search == null ? null : to.query.search;
      this.leagueId = +to.query.league || this.leagueId || null;
      this.leagueView = to.query["league-view"] || this.leagueView || "matches";
      this.day = to.query.day || this.day || null;
      this.weekNumber = +to.query.week || this.weekNumber || null;
      if (to.query.search == "league" && to.query.league != null && to.query["league-view"] == null) {
        this.$router.replace({path: `/leagues/schedule/${this.season.id}`, replace: true, query: {search: this.searchChoice, league: this.leagueId, 'league-view': this.leagueView}});
        return;
      }
      if (!this.searchChoice) {
      } else if ((to.query.league || to.query.day || to.query.week) == null) {
        let path = to.path;
        if (this.searchChoice == "league" && this.leagueId != null) {
          path += `?search=league&league=${this.leagueId}&league-view=matches`;
          this.$router.replace({path: path, replace: true});
        } else if (this.searchChoice == "week" && this.weekNumber != null) {
          path += `?search=week&&week=${this.weekNumber}`;
          this.$router.replace({path: path, replace: true});
        } else if (this.searchChoice == "day" && this.day != null) {
          path += `?search=day&day=${this.day}`;
          this.$router.replace({path: path, replace: true});
        }
      }
      this.fetchData();
    },
    fetchData() {
      if (this.searchChoice == null) return;
      let url = `${this.$apiRoot}/matches/?season=${this.season.id}`;
      if (this.searchChoice == "league" && this.leagueId != null && this.leagueView == 'matches') {
        url += `&league=${this.leagueId}`;
      } else if (this.searchChoice == "week" && this.weekNumber != null) {
        url += `&week=${this.weekNumber}`;
      } else if (this.searchChoice == "day" && this.day != null) {
        url += `&date=${this.day}`;
      } else {
        return;
      }
      let loadNumber = ++this.loadingCounter;
      this.loading = true;
      let promise = this.axios.get(url);
      promise.then(result => {
        if (this.loadingCounter != loadNumber) return;
        this.loading = false;
        this.matches = result.data;
      }).catch(() => {
        if (this.loadingCounter != loadNumber) return;
        this.loading = false;
        this.matches = [];
      });
    },
    getRecord(teamName, leagueId) {
      return this.teams[`${leagueId} ${teamName}`].record;
    }
  },
  filters: {
    formatDate(date) {
      return moment(date).format("MMMM Do YYYY");
    }
  }
}
</script>

<style lang="scss">
.schedule .title {
  margin-top: 1.5rem;
}
.schedule .datepicker-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  justify-items: center;
  align-content: center;
  margin-bottom: 1.5rem;
}
.matches-list {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 500px) {
    overflow-x: auto;
    display: block;
    flex-direction: initial;
    justify-content: initial;
    align-items: initial;
  }
  table {
    page-break-before: always;
    page-break-after: always;
    page-break-inside: avoid;
  }
  table {
    table-layout: fixed;
    min-width: 500px;
    @media (min-width: 500px) {
      width: 90%;
      margin: 0 0.5rem 1.5rem;
      .row-time {
        width: 12%;
      }
      .row-court {
        width: 12%;
      }
      .row-team {
        width: 39%;
      }
    }
    @media (min-width: 900px) {
      width: 75%;
      margin: 0 0.5rem 1.5rem;
      .row-time {
        width: 10%;
      }
      .row-court {
        width: 10%;
      }
      .row-team {
        width: 43%;
      }
    }
    @media (min-width: 1200px) {
      width: 55%;
      margin: 0 0.5rem 1.5rem;
    }
    .table-caption {
      margin-bottom: 0.5rem;
    }
  }
}
.num-wins {
  color: darken(lightgreen, 10%);
}
.num-losses {
  color: lightcoral;
}
.bracket-link {
  font-weight: 700;
}
</style>